import { useQuery, useQueryClient } from '@tanstack/react-query'
import { config } from '../lib/api.js'
import { useI18n } from '../lib/i18n.js'
import { Spinner } from '../components/ui/index.js'
import { LocaleForm } from '../components/LocaleForm.js'
import { TargetLocalesForm } from '../components/TargetLocalesForm.js'

/**
 * Traduções (#336) — idiomas do menu fora do Branding: idioma principal,
 * idiomas-alvo da tradução por IA, status ao vivo das execuções e o botão
 * de atualizar/retentar (antes tudo isso vivia em /r/:slug/branding).
 */
export function Translations() {
  const qc = useQueryClient()
  const { t } = useI18n()

  const { data: cfg, isLoading } = useQuery({
    queryKey: ['config'],
    queryFn: () => config.get(),
  })

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Spinner className="w-8 h-8" />
      </div>
    )
  }

  return (
    <div className="space-y-6 max-w-3xl" data-testid="translations-page">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">{t('admin.translations.title')}</h1>
        <p className="text-sm text-gray-500 mt-1">{t('admin.translations.subtitle')}</p>
      </div>

      {cfg && <LocaleForm cfg={cfg} qc={qc} />}
      {cfg && <TargetLocalesForm cfg={cfg} qc={qc} />}
    </div>
  )
}
